module.exports = __webpack_public_path__ + "static/images/jf-cxtj2.ae8ec12.png";